import { render, staticRenderFns } from "./HolidaysParticipantsPrintListByGroup.vue?vue&type=template&id=48ec0312&scoped=true&"
import script from "./HolidaysParticipantsPrintListByGroup.vue?vue&type=script&lang=ts&"
export * from "./HolidaysParticipantsPrintListByGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ec0312",
  null
  
)

export default component.exports